/* eslint-disable react-hooks/exhaustive-deps */
import { TEXT_SIZE, TwirlTextContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { TextAlignment } from "@blueprintjs/core"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { Color } from "src/libs/interfaces/layouts"
import chroma from "chroma-js"
import "./style.scss"

/* Protopia Ecosystem component */ 
const TwirlTextPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: TwirlTextContent = (props.primitive || {}) as TwirlTextContent 
    const { text, text_color, twirl_text, twirl_text_color, style, className, text_align, text_family, text_size, twirl_tail_delay, delay} = primitive
    let timer: any
    const [count, setCount] = useState(0)
  
    const updateCount = () => {
        timer = !timer && setInterval(() => {
            // console.log( count )
            setCount(prevCount => prevCount + 1)
        }, delay || 4000)
    }
    const getTwirlColors = (): Color[] => {
        const twirlColors = !!twirl_text_color ? twirl_text_color : text_color || "var(--force-contast-color)"
        if(Array.isArray(twirlColors)){
            const clr: Color[] = chroma.scale( twirlColors ).colors(twirl_text.length);
            return clr
        }
        return twirl_text.map(t => twirlColors)
    }
    const getWord = (i: number) => {
        const cw = (i + twirl_text.length) % twirl_text.length 
        const word = twirl_text[ cw ]
        const letters = word.split( "" ) 
        return <span className="word" style={{color: twirlColors[ cw]}} >
        { 
            letters.map( (letter, ii) => {
                const className = `letter ${letter === " " ? "space" : ""} ${ i === count ? "cur-letter" : "next-letter"}`
                const style = { animationDelay: `${ii * ( !!twirl_tail_delay ? Number(twirl_tail_delay) : 0 ) }s` }
                return <span className={ className } key={ word + ii } style={style}>
                    { letter }
                </span> 
            })
        }
        </span>
    } 
    const [twirlColors, setTwirlColors] = useState<Color[]>(getTwirlColors()) 

    useEffect(() => {
        addCSSClass(
            `primitive-writer-${ primitive.id }`,
            ` .primitive-writer-${ primitive.id } {
                text-align:${text_align || TextAlignment.START};
                ${ text_size   ? `font-size: ${ TEXT_SIZE[ text_size ] }em;` : "" }
                ${ text_color  ? `color: ${text_color}` : "" };
                ${ text_family ? `font-family: ${text_family }` : ""

            }`
        ) 
        updateCount()
        return () => {
            clearInterval( timer )
            removeCSSClass(`primitive-writer-${ primitive.id }`)
        }
    },[ primitive ])

    return <div className={`landing-twirl-text ${className || ""}`} style={style}>
        <p>{ text }</p>
        <p className="position-relative">{ getWord( count ) }{ getWord( count - 1 ) }</p> 
    </div>
}
export default TwirlTextPrimitive
